import jQuery from 'jquery';
import ready from '../util/ready';
import {log} from "../util/logger";

export default function ($ = jQuery) {
  ready(() => {

    // Show sub menues for the current item
    $('.current-menu-item.menuItem').each(function () {
      $(this).addClass('is-expanded');
    });

    const menus = $('.js-menu');

    //If the startlevel on say a vertical menu is 2, we want to hide level 0 and 1
    const submenus = $('.js-menuWidget.is-submenu');
    submenus.each(function () {
      const currentStartlevel = $(this).data('startlevel');
      for (let i = 0; i < currentStartlevel; i++) {
        $(this).find('.js-menuLink.is-level' + (i + 1)).addClass('is-hiding');
      }
    });

    // Toggle visibility of sub menus
    menus.on('click', '.js-menuCaret', function (event) {
      $(this).parent().parent().toggleClass('is-expanded');
      event.stopPropagation();
      event.preventDefault();
    });

    //Toggle hamburger menu
    $('.js-hamburgerToggle').on('click', function () {
      const menuContainer = $(this).closest('.js-menuContainer').find('.js-hamburgerMenuContainer');
      menuContainer.toggleClass('is-hidden');
      $(this).toggleClass('is-active');
    });

    log('Menu init');
  });
};
